class RolifeDifficultyTabs extends HTMLElement {
  #controller;

  connectedCallback() {
    if (this.#controller) return;
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    const tabs = this.tabs;

    for (const tab of tabs) {
      tab.addEventListener(
        'click',
        () => {
          this.activate(tab.dataset.rolifeTab, false);
        },
        { signal }
      );
      tab.addEventListener(
        'keydown',
        (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const activeIndex = Math.max(
            0,
            tabs.findIndex((item) => item.getAttribute('aria-selected') === 'true')
          );
          let nextIndex = activeIndex;
          if (event.key === 'ArrowRight') nextIndex = (activeIndex + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (activeIndex - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          this.activate(tabs[nextIndex].dataset.rolifeTab, true);
        },
        { signal }
      );
    }
  }

  disconnectedCallback() {
    this.#controller?.abort();
    this.#controller = undefined;
  }

  get tabs() {
    return [...this.querySelectorAll('[data-rolife-tab]')];
  }

  get panels() {
    return [...this.querySelectorAll('[data-rolife-panel]')];
  }

  activate(key, focusTab = false) {
    const selectedTab = this.tabs.find((tab) => tab.dataset.rolifeTab === key);
    const selectedPanel = this.panels.find((panel) => panel.dataset.rolifePanel === key);
    if (!selectedTab || !selectedPanel) return;

    for (const tab of this.tabs) {
      const selected = tab === selectedTab;
      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;
    }
    for (const panel of this.panels) {
      panel.hidden = panel !== selectedPanel;
    }
    if (focusTab) selectedTab.focus();
    this.dispatchEvent(
      new CustomEvent('rolife:difficulty-change', {
        bubbles: true,
        detail: { difficulty: key }
      })
    );
  }
}

if (!customElements.get('rolife-difficulty-tabs')) {
  customElements.define('rolife-difficulty-tabs', RolifeDifficultyTabs);
}
